<template>
  <!-- D: 마이룸-->
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">마이룸</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <div class="tab-header-3">
        <button
          class="tab-button-3"
          data-target="panel3-1"
          @click="btnCmd({ tab1Index: 0 })"
          :class="[
            {
              active: data.tab1Index === 0,
            },
          ]"
        >
          제품추가검색
        </button>
        <button
          class="tab-button-3"
          data-target="panel3-2"
          @click="btnCmd({ tab1Index: 1 })"
          :class="[
            {
              active: data.tab1Index === 1,
            },
          ]"
        >
          마이룸
        </button>
      </div>

      <button
        type="button"
        class="c-util-button type-primary type-modal-pr"
        @click="showEditGroup"
        :hidden="data.tab1Index != 0"
      >
        <span>그룹 추가/편집</span>
      </button>

      <div class="c-use-table c-use-table-pr" :hidden="data.tab1Index != 1">
        <table>
          <caption>
            제품군 선택 테이블
          </caption>
          <colgroup>
            <col style="width: 17.937%" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>
                <button type="button" class="btn-expand">
                  <span class="text">마이룸 그룹</span>
                  <span class="sr-only">펼침</span>
                  <i class="c-icon icon-plus-black size-xxsmall"></i>
                </button>
              </th>
              <td>
                <div class="options">
                  <div class="option-inner">
                    <!-- D: 클릭시 is-active -->
                    <template
                      v-for="item in data.grouptList"
                      :key="item.groupSn"
                    >
                      <button
                        type="button"
                        class="c-option-item"
                        :class="
                          data.selectGroupSn == item.groupSn ? 'is-active' : ''
                        "
                        @click="data.selectGroupSn = item.groupSn"
                      >
                        <span class="text">{{ item.groupName }} </span>
                      </button>
                    </template>

                    <button
                      type="button"
                      class="c-option-item type-primary type-modal-pr"
                      data-popup-open="#popupID"
                    >
                      <span class="text" @click="showEditGroup"
                        >그룹 추가/편집</span
                      >
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
      <div class="type-non-border">
        <!-- tab content: tab1 -->
        <div
          class="tab-panel"
          role="tabpanel"
          aria-labelledby="tab1-1"
          :hidden="data.tab1Index != 0"
        >
          <MyRoomProdList :orderSheet="orderSheet" />
        </div>
        <!-- tab content: tab2 -->
        <div
          class="tab-panel"
          role="tabpanel"
          aria-labelledby="tab1-2"
          :hidden="data.tab1Index != 1"
        >
          <MyRoomBasket
            :orderSheet="orderSheet"
            :groupSn="data.selectGroupSn"
            :tabIndex="data.tab1Index"
          ></MyRoomBasket>
        </div>
      </div>
      <!-- // D: 상단 탭 : 제품추가검색, 마이룸 -->

      <!-- D: 주문내역 조회&목록 -->
      <!-- <OrderHistoryCont /> -->
    </div>

    <OrderSheet ref="orderSheet" />

    <QuickMenu />
  </div>

  <ProdInfoPop
    v-if="isShowProdInfoPop"
    v-bind="prodInfoPopProps"
    @close="() => (isShowProdInfoPop = false)"
  />

  <MyRoomGroupPop
    v-if="data.popup.isShowGroupInfoPop"
    @group-update="onGroupUpdate"
    @close="() => (data.popup.isShowGroupInfoPop = false)"
  />
</template>
<script setup name="myRoom">
import { onMounted, reactive, watch, computed, ref, inject } from "vue";
import MyRoomGroupPop from "@/components/paintpro/myRoom/myRoomGroupPop.vue";
import MyRoomBasket from "@/components/paintpro/myRoom/basket.vue";
import ProdInfoPop from "@/components/paintpro/prod/prodInfoPop.vue";
import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import MyRoomProdList from "@/components/paintpro/myRoom/myRoomProdList.vue";
import { useRoute } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";
import OrderSheet from "@/components/paintpro/prod/orderSheet.vue";
import { api } from "@/plugins/api";
import utils from "@/js/utils";

const url = inject("url_prefix");
const orderSheet = ref();
const prodInfoPopProps = ref({ matnr: null });
const isShowProdInfoPop = ref(false);

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
    query: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    isShowGroupInfoPop: false,
  },
  tab1Index: 0,
  grouptList: [],
  selectGroupSn: "",
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  data.tab1Index = 0;
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: orderList_index.pageInitData] `);
    return false;
  }
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;

  selectGroupList();
}

async function selectGroupList() {
  const res = await api.post(`${url}/myRoom/group/select`);
  if (res.resultCode === 200) {
    data.grouptList = res.data;
    data.selectGroupSn = res.data[0] == null ? "" : res.data[0].groupSn;
  }
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "마이룸", path: "/paintpro/myRoom/prod" },
    { name: "제품조회", path: "" },
  ];
  return list;
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(parms = {}) {
  data.tab1Index = parms.tab1Index;
}

// 그룹관리
function showEditGroup() {
  data.popup.isShowGroupInfoPop = true;
}

//그룹데이터 재설정
function onGroupUpdate(groupData) {
  data.grouptList = groupData;

  let groupSn = null;
  if (data.grouptList.length > 0) {
    groupSn = data.grouptList.find(
      (item) => item.groupSn == data.selectGroupSn
    );
  }

  if (utils.isBlank(groupSn)) {
    data.selectGroupSn = "";
  }
}
</script>
<style scoped></style>
